module.exports = __webpack_public_path__ + "assets/clear_text-38b96b.svg";